import { clsx } from 'clsx'

import { Drawer as StyledDrawer, DrawerContent } from '@/components/ui/drawer'

import { useDrawer } from '../../context/DrowerContext'

const DrawerWrapper = () => {
  const { open, closeDrawer, content, isNestedOpen, closeNestedDrawer, nestedContent } = useDrawer()

  return (
    <>
      <StyledDrawer open={open} onOpenChange={(isOpen) => !isOpen && closeDrawer()}>
        <DrawerContent
          className={clsx(
            'bg-background-general-light dark:bg-background-general-dark border border-tertiary-border min-w-96 text-text',
            {
              'w-180': !isNestedOpen,
              'w-275': isNestedOpen,
            },
          )}
        >
          {content}
        </DrawerContent>
      </StyledDrawer>
      <StyledDrawer open={isNestedOpen} onOpenChange={(isOpen) => !isOpen && closeNestedDrawer()}>
        <DrawerContent className='bg-background-general-light dark:bg-background-general-dark border border-tertiary-border min-w-96 w-180 text-text'>
          {nestedContent}
        </DrawerContent>
      </StyledDrawer>
    </>
  )
}

export default DrawerWrapper
